<template>
  <v-container v-if="!userIsRecepcion()" class="fill-height">
    <NoPermission />
  </v-container>
  <div v-if="userIsRecepcion()">
    <div class="d-flex align-center mb-4">
      <DatePicker v-model="selectedDate" />
    </div>
    <v-data-table-server
      :headers="headers"
      :items-per-page="perPage"
      :items="buzones"
      :page="page"
      :items-length="totalBuzones"
      :loading="loading"
      :item-value="id"
      :server-items-length="totalBuzones"
      @update:page="onPageChange"
      @update:items-per-page="onItemsPerPageChange"
      class="elevation-1"
      show-expand
      expand-on-click="false"
      :expanded="expanded"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <!--  <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar"
            single-line
            hide-details
            @input="loadBuzones"
          ></v-text-field> -->
          <v-spacer></v-spacer>
          <v-btn color="primary" dark class="mb-2" @click="newItem()"
            >Nuevo</v-btn
          >
        </v-toolbar>
      </template>
      <template v-slot:[`item.caja_fecha`]="{ item }">
        {{ formatDate(item.caja_fecha) }}
      </template>
      <template v-slot:[`item.importe`]="{ item }">
        {{ formatCurrency(item.importe) }} €
      </template>
      <template #[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click="editItem(item)" color="green">
          mdi-pencil
        </v-icon>
        <v-icon small @click="deleteItem(item)" color="red">
          mdi-delete
        </v-icon>
      </template>
      <template v-slot:expanded-row="{ item }">
        <tr
          v-if="item.detalle && item.detalle.trim() !== ''"
          class="expanded-detalle"
        >
          <td :colspan="headers.length">
            <div class="pa-4">{{ item.detalle }}</div>
          </td>
        </tr>
      </template>
    </v-data-table-server>
  </div>
</template>

<script setup>
import { ref, onMounted, watch, nextTick, inject } from 'vue'
import { storeToRefs } from 'pinia'
import { useBuzonesStore } from '@/stores/buzonesStore'
import { useCajaStore } from '@/stores/cajaStore'
import { formatCurrency, formatDate, userIsRecepcion } from '@/utils/helpers'
import DatePicker from '@/components/common/DatePicker.vue'
import NoPermission from '@/components/common/NoPermission.vue'

const buzonesStore = useBuzonesStore()
const { buzones, totalBuzones, page, perPage } = storeToRefs(buzonesStore)
const loading = ref(false)
const search = ref('')
const cajaStore = useCajaStore()
const selectedDate = ref(null)
const cajaReady = inject('cajaReady', ref(true)) // Default to true if not provided

// Computed property para mantener expandidas todas las filas
// const expandedItems = computed(() =>
//   buzones.value.filter((item) => item.detalle !== '').map((item) => item.id)
// )
const expanded = ref([])

const emit = defineEmits(['editItem', 'deleteItem', 'newItem'])

const headers = [
  { title: 'Fecha', key: 'caja_fecha', align: 'center' },
  { title: 'Usuario', key: 'usuario_iniciales', align: 'center' },
  { title: 'Turno', key: 'turno', align: 'center' },
  { title: 'Registro', key: 'registro', align: 'center' },
  { title: 'Detalle', key: 'detalle', align: 'center' },
  { title: 'Importe', key: 'importe', align: 'end' },
  { title: '', key: 'data-table-expand' },
  {
    title: '  ',
    width: '100px',
    key: 'actions',
    sortable: false,
    align: 'end'
  }
]

onMounted(async () => {
  // Wait for cajaReady to be true before loading data
  if (cajaReady.value) {
    initializeData()
  } else {
    // Watch for changes in cajaReady
    const unwatch = watch(cajaReady, (newValue) => {
      if (newValue === true) {
        initializeData()
        unwatch() // Stop watching once initialized
      }
    })
  }
})

const initializeData = () => {
  nextTick(async () => {
    const fecha = cajaStore.lastCaja?.fecha || new Date()
    if (fecha instanceof Date) {
      const year = fecha.getFullYear()
      const month = String(fecha.getMonth() + 1).padStart(2, '0')
      const day = String(fecha.getDate()).padStart(2, '0')
      selectedDate.value = `${year}-${month}-${day}`
    } else {
      selectedDate.value = fecha
    }
    // await loadBuzones()
  })
}

// Observar cambios en la fecha seleccionada
watch(selectedDate, () => {
  loadBuzones()
})

const loadBuzones = async () => {
  loading.value = true
  let fecha = selectedDate.value || null
  await buzonesStore.fetchBuzones({ search: search.value, fecha: fecha })
  loading.value = false
}

const onPageChange = (newPage) => {
  buzonesStore.setPage(newPage)
  loadBuzones()
}

const onItemsPerPageChange = (newItemsPerPage) => {
  perPage.value = newItemsPerPage
  buzonesStore.setRows(newItemsPerPage)
  loadBuzones()
}

const deleteItem = (item) => {
  emit('deleteItem', item)
}

const editItem = (item) => {
  emit('editItem', item)
}

const newItem = () => {
  emit('newItem')
}

defineExpose({
  loading,
  search,
  headers,
  buzones,
  editItem,
  deleteItem,
  newItem,
  formatDate,
  formatCurrency
})
</script>
